import React from 'react'
import '../../images/banner.jpg'

const Header = () => {

  return (
    <>
         <section class="home" id="home">
         <div class="max-width">
            <div class="home-content">
            <header className='d-flex page-header justify-content-between '>         
         <div className='header-text'>
               <h2 className='texth2'style={{"font-weight":"900", "font-size":"25px" }}>Welcome To ORATECH</h2>
                <p className='paragraph-text m-0 p-0 mx-auto'>ORATECH
                is a third party company in telecommunication industry playing a major role in distribution, 
                offering affordable and the cheapest data, airtime, Dstv subscription, Gotv subscription, Startimes subscription etc
                </p>
                <div className='btn'>
                  <a href="https://sabuss.com/latoof6/?register" className='btnRegister' > Regiser</a>
                  <a href="https://sabuss.com/latoof6/?login" className="btnLogin"> Login</a>
               </div>
               <a href="https://play.google.com/store/apps/details?id=oratech.mobile.app" className='btnplaystore' > 
                        <img src="assets/playstore.png" alt="logo" className='Playstore1 ms-1'/>  </a>
                 <div className='mt-4'>
                 <p className=''style={{"font-weight":"900" }}>Trusted by Companies like: </p>
                 </div>
                 <div className='network'>
               <img src="assets/mtn.png" alt="logo" className='networkLogo ms-1'/>  
                 <img src="assets/glo.png" alt="logo" className='networkLogo ms-1'/>  
              <img src="assets/airtel.png" alt="logo" className='networkLogo ms-1'/>  
                 <img src="assets/9mobile.png" alt="logo" className='networkLogo ms-1'/> 
              
                 </div>
                
         </div> 
         <div className='img'>
         <img src="assets/11t.png" alt="logo" className='logo ms-1'/>  
          </div>                
     </header>
          </div> 
          </div>    
     </section>
    </>
  )
}

export default Header